import configForm from './_configForm'
import paths from './_paths'

export default (name, data) => {
  return configForm().post(paths[name], data).catch(error => {
    if (error.response.status === 419) {
      window.location.reload()
      return
    }
    throw new Error(`Api Service POST ${paths[name]} Failed: ${error}`)
  })
}
